import React, { Component, createRef, Fragment } from "react";
import "component/details/Info/styles.scss";
import { ReactComponent as ArrowDown } from "assets/icons/arrow-down-2.svg";
import { ReactComponent as ArrowUp } from "assets/icons/arrow-up.svg";
import { ReactComponent as CrownIcon } from "assets/icons/Jackpot.svg";
import { ReactComponent as TrophyIcon } from "assets/icons/Tournament.svg";
import { ReactComponent as RibbonIcon } from "assets/icons/FreeRounds.svg";
import { ReactComponent as EditorsChoiceIcon } from "assets/icons/editors-badge.svg";
import { getTotalPool } from "utils/getTotalpool";
import ShowMoreText from "react-show-more-text";
import { HAN_REGEX } from "utils/constants";
import { currencyFormatter } from "utils/currencyHelper";
import { renderWithBoldHelper } from "utils/renderWithBoldHelper";

import isEmpty from "lodash/isEmpty";
import { withTranslation } from "react-i18next";

class Info extends Component {
  constructor(props) {
    super(props);
    this.topPosition = createRef();
    this.onClickName = this._onClickName.bind(this);
    this.handleDescription = this._handleDescription.bind(this);
    this.getTotalPool = getTotalPool.bind(this);
    this.state = {
      hasDescription:
        props.details && !isEmpty(props.details.get("description")),
      activeDetails: false,
      expandDescription: false,
      jackpotPool: null,
    };
  }

  componentDidMount() {
    if (!this.props.isMobile) this.setState({ activeDetails: true });
  }

  _onClickName() {
    this.setState({ activeDetails: !this.state.activeDetails });
  }

  _handleDescription() {
    let btns = document.getElementsByClassName(
      `description-clickable ${this.props.gameIndex}`,
    );
    if (btns.length > 1) {
      if (this.state.expandDescription) {
        btns[0].click();
      } else {
        btns[1].click();
      }
      this.setState({ expandDescription: !this.state.expandDescription });
      if (this.props.handleDescription) {
        this.props.handleDescription();
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.details &&
      nextProps.latestBroadcast &&
      nextProps.latestBroadcast.get("jackpotGroupId") ===
        this.props.details.get("jackpotGroupId")
    ) {
      let latestJackpotPool;
      latestJackpotPool = {
        type: nextProps.latestBroadcast.get("type"),
        amount: nextProps.latestBroadcast.get("amount"),
      };
      this.setState({
        jackpotPool: {
          ...this.state.jackpotPool,
          [latestJackpotPool.type]: { amount: latestJackpotPool.amount },
        },
      });
    } else {
      this.setState({ jackpotPool: null });
    }
  }

  render() {
    const { isMobile, t } = this.props;

    return (
      <div
        className={`component-info showBorder ${
          isMobile ? "mobile" : "desktop"
        }`}
        ref={this.topPosition}
      >
        <div
          className={`name text-center d-flex justify-content-between align-items-center`}
          onClick={() => {
            if (isMobile) {
              this.onClickName();
            }
          }}
        >
          <div className="game-name">
            <span className="game-feature-badge">
              {this.props.details &&
                this.props.details.get("partOfOnGoingTournament") && (
                  <span className="trophyIcon">
                    <TrophyIcon color="rgba(255, 204, 0, 1)" selectedcolor="" />
                  </span>
                )}
            </span>
            {this.props.details && this.props.details.get("name")}
            {!this.props.details && <span className="dummy">XXXXXXXXXX</span>}
          </div>

          <div className="row name-provider">
            <div className="col">
              {this.props.details && this.props.details.get("provider")}
              {!this.props.details && <span className="dummy">XXXXXXXXXX</span>}
            </div>
          </div>

          {isMobile && (
            <div>
              {" "}
              {this.state.activeDetails ? <ArrowUp /> : <ArrowDown />}{" "}
            </div>
          )}
        </div>
        {this.props.details && this.props.details.get("isJackpot") && (
          <span className="game-feature-badge jackpotIcon">
            <CrownIcon color="rgba(255, 204, 0, 1)" />
            {renderWithBoldHelper(
              t,
              "totalJackpotPoolOf",
              "amount",
              this.getTotalPool(
                this.state.jackpotPool,
                this.props.details,
                false,
              ),
            )}
          </span>
        )}
        {this.props.details && this.props.details.get("totalFreePlayAmount") && (
          <span className="game-feature-badge ribbonIcon">
            <RibbonIcon color="rgba(255, 204, 0, 1)" />
            {renderWithBoldHelper(
              t,
              "enjoyInFreePlay",
              "amount",
              currencyFormatter(this.props.details.get("totalFreePlayAmount"), {
                currency: this.props.currency,
              }),
            )}
          </span>
        )}
        {this.props.details && this.props.details.get("isFeatured") && (
          <span className="game-feature-badge editorsChoiceIcon">
            <EditorsChoiceIcon color="rgba(255, 204, 0, 1)" />
            {t("editorsChoice")}
          </span>
        )}
        {this.state.activeDetails && (
          <div className="description">
            {this.props.details && this.props.details.get("description") && (
              <div
                onClick={() => {
                  this.handleDescription();
                }}
              >
                {this.props.details.get("description").match(HAN_REGEX) ? (
                  <>
                    <span className="description-sub">
                      {this.props.details.get("description").substring(0, 65)}
                    </span>
                    <ShowMoreText
                      lines={3}
                      more={t("more")}
                      less=""
                      className="description"
                      anchorClass={`description-clickable ${
                        this.props.gameIndex
                      }`}
                      onClick={this.executeOnClick}
                      expanded={this.props.expandDescription ? true : false}
                      truncatedEndingComponent={"... "}
                    >
                      {this.props.details.get("description").substring(65)}
                    </ShowMoreText>
                  </>
                ) : (
                  <ShowMoreText
                    lines={3}
                    more={t("more")}
                    less=""
                    className="description"
                    anchorClass={`description-clickable ${
                      this.props.gameIndex
                    }`}
                    onClick={this.executeOnClick}
                    expanded={this.props.expandDescription ? true : false}
                    truncatedEndingComponent={"... "}
                  >
                    {this.props.details.get("description")}
                  </ShowMoreText>
                )}
              </div>
            )}
            {!this.props.details && (
              <span className="dummy">
                XXXXXX XXXXX XXXXXXX XXXXXX XX XXXXXXX XXXXX XXX XXXXXXX XX
                XXXXXXX XXXXX XXX XXXXXXX XX XXXXXXX XXXXX XXX XXXXXXX
              </span>
            )}
          </div>
        )}

        {this.state.activeDetails && (
          <div className="info showBorder">
            <div className="row">
              {this.props.details && (
                <Fragment>
                  <div className="col-4 label">{t("type")}:</div>
                  <div className="col">
                    {this.props.details.get("gameType")}
                  </div>
                </Fragment>
              )}
              {!this.props.details && (
                <Fragment>
                  <div className="col-4 label">
                    <span className="dummy">XXXXXXX</span>:
                  </div>
                  <div className="col">
                    <span className="dummy">XXXXXXXXXXX</span>
                  </div>
                </Fragment>
              )}
            </div>
            <div className="row">
              {this.props.details &&
                this.props.details.get("themes") &&
                this.props.details.get("themes").size > 0 && (
                  <Fragment>
                    <div className="col-4 label">{t("themes")}:</div>
                    <div className="col">
                      {this.props.details
                        .get("themes")
                        .toJSON()
                        .join(", ")}
                    </div>
                  </Fragment>
                )}
              {!this.props.details && (
                <Fragment>
                  <div className="col-4 label">
                    <span className="dummy">XXXXXX</span>:
                  </div>
                  <div className="col">
                    <span className="dummy">XXXXXXXXXX</span>
                  </div>
                </Fragment>
              )}
            </div>

            <div className="row">
              {this.props.details &&
                this.props.details.get("specialFeatures") &&
                this.props.details.get("specialFeatures").size > 0 && (
                  <Fragment>
                    <div className="col-4 label">{t("features")}:</div>
                    <div className="col">
                      {this.props.details
                        .get("specialFeatures")
                        .toJSON()
                        .join(", ")}
                    </div>
                  </Fragment>
                )}
              {!this.props.details && (
                <Fragment>
                  <div className="col-4 label">
                    <span className="dummy">XXXXXXXXXXX</span>:
                  </div>
                  <div className="col">
                    <span className="dummy">
                      XXXXXXXXXXX XXXXXX XX XXXXXXX XXXXX XXX XXXXXXX
                    </span>
                  </div>
                </Fragment>
              )}
            </div>

            <div className="row">
              {this.props.details &&
                this.props.details.get("volatility") &&
                this.props.details.get("volatility") !== "" && (
                  <Fragment>
                    <div className="col-4 label">{t("variance")}:</div>
                    <div className="col">
                      {this.props.details.get("volatility")}
                    </div>
                  </Fragment>
                )}
              {!this.props.details && (
                <Fragment>
                  <div className="col-4 label">
                    <span className="dummy">XXXXXXXXXXX</span>:
                  </div>
                  <div className="col">
                    <span className="dummy">XXXXXXXXXXX XXXXXX</span>
                  </div>
                </Fragment>
              )}
            </div>

            <div className="row">
              {this.props.details && this.props.details.get("releaseDate") && (
                <Fragment>
                  <div className="col-4 label">{t("releaseDate")}:</div>
                  <div className="col">
                    {this.props.details.get("releaseDate")}
                  </div>
                </Fragment>
              )}
              {!this.props.details && (
                <Fragment>
                  <div className="col-4 label">
                    <span className="dummy">XXXXXXXXXXX</span>:
                  </div>
                  <div className="col">
                    <span className="dummy">XXXXXXXXXXX XXXXXX</span>
                  </div>
                </Fragment>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation("translation")(Info);
